/* ────────────────────────────────────────────────────────────────
   Kushface — Test Card scroll-tune (standalone)
   Mirrors the homepage broadcast-bar effect (home-scroll.js GSAP
   ScrollTrigger) without the GSAP dependency, so the bars "tune"
   on scroll on interior pages too. Only loaded off the homepage
   (the homepage uses the GSAP version) to avoid double-driving.
   ──────────────────────────────────────────────────────────────── */

(function () {
  "use strict";

  // The section can render multiple times per page (one tag per strip),
  // so the script may load more than once — init only on the first run.
  if (window.__kfTestcardScrub) return;
  window.__kfTestcardScrub = true;

  function init() {
    var cards = document.querySelectorAll(".kf-testcard");
    if (!cards.length) return;
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }

    var items = [];
    Array.prototype.forEach.call(cards, function (card) {
      var bars = card.querySelector(".kf-testcard__bars");
      if (!bars) return;
      var rev = card.hasAttribute("data-reverse");
      items.push({ bars: bars, card: card, from: rev ? 18 : -18, to: rev ? -18 : 18 });
    });
    if (!items.length) return;

    var ticking = false;

    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      items.forEach(function (it) {
        var r = it.card.getBoundingClientRect();
        // 0 when the card's top hits the viewport bottom, 1 when its
        // bottom hits the viewport top (matches the GSAP start/end).
        var p = (vh - r.top) / (vh + r.height);
        if (p < 0) p = 0;
        else if (p > 1) p = 1;
        var x = it.from + (it.to - it.from) * p;
        it.bars.style.backgroundPositionX = x.toFixed(2) + "vw";
      });
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
